export function normalizeUrlWithParts(parts: string[], separator = '/') {
    const regexp = new RegExp(`((?!:).|^)${separator}{2,}`, 'g');
    return parts.join(separator).replace(regexp, separator);
}

export function getQueryParams(url: string) {
    return new URLSearchParams(url);
}

export function getFullUrl(params: any, baseUrl = '', url = '') {
    let fullUrl = `${baseUrl}/${url.startsWith('/') ? url.slice(1) : url}`;
    if (params) {
        const urlSearchParams = new URLSearchParams(params);
        const urlSearchParamsStr = urlSearchParams.toString();
        if (urlSearchParamsStr) {
            fullUrl = `${fullUrl}?${urlSearchParamsStr}`;
        }
    }
    return fullUrl;
}
